/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface BigCommerceHealthcheckRequest
 */
export interface BigCommerceHealthcheckRequest {
  /**
   *
   * @type {string}
   * @memberof BigCommerceHealthcheckRequest
   */
  integrationId: string;
}

/**
 * Check if a given object implements the BigCommerceHealthcheckRequest interface.
 */
export function instanceOfBigCommerceHealthcheckRequest(
  value: object,
): value is BigCommerceHealthcheckRequest {
  if (!("integrationId" in value) || value["integrationId"] === undefined)
    return false;
  return true;
}

export function BigCommerceHealthcheckRequestFromJSON(
  json: any,
): BigCommerceHealthcheckRequest {
  return BigCommerceHealthcheckRequestFromJSONTyped(json, false);
}

export function BigCommerceHealthcheckRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): BigCommerceHealthcheckRequest {
  if (json == null) {
    return json;
  }
  return {
    integrationId: json["integrationId"],
  };
}

export function BigCommerceHealthcheckRequestToJSON(
  json: any,
): BigCommerceHealthcheckRequest {
  return BigCommerceHealthcheckRequestToJSONTyped(json, false);
}

export function BigCommerceHealthcheckRequestToJSONTyped(
  value?: BigCommerceHealthcheckRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    integrationId: value["integrationId"],
  };
}
